const translations = {
    'en': {
        singular: ' millisecond| second| minute| hour| day| week| month| year| decade| century| millennium',
        plural: ' milliseconds| seconds| minutes| hours| days| weeks| months| years| decades| centuries| millennia',
        last: ' and ',
        empty: 'now'
    },
    'en-gb': {
        singular: ' millisecond| second| minute| hour| day| week| month| year| decade| century| millennium',
        plural: ' milliseconds| seconds| minutes| hours| days| weeks| months| years| decades| centuries| millennia',
        last: ' and ',
        empty: 'now'
    },
    'de': {
        singular: ' Millisekunde| zweite| Minute| Stunde| Tag| Woche| Monat| Jahr| Jahrzehnt| Jahrhundert| Millennium',
        plural: 'Millisekunden| Sekunden| Minuten| Stunden| Tage| Wochen| Monate| Jahre| Jahrzehnte| Jahrhunderte| Jahrtausende',
        last: ' und ',
        empty: 'jetzt'
    },
    'es': {
        singular: ' milisegundo| segundo| minuto| hora| dia| semana| mes| año| década| siglo| milenio',
        plural: ' milisegundos| segundos| minutos| horas| dias| semanas| meses| años| décadas| siglos| milenios',
        last: ' y ',
        empty: 'ahora'
    },
    'fr': {
        singular: ' milliseconde| seconde| minute| heure| jour| semaine| mois| année| décennie| siècle| millénaire',
        plural: ' millisecondes| secondes| minutes| heures| jours| semaines| mois| années| décennies| siècles| millénaires',
        last: ' et ',
        empty: 'maintenant'
    },
    'it': {
        singular: ' millisecondo| secondo| minuto| ora| giorno| settimana| mese| anno| decennio| secolo| millennio',
        plural: ' millisecondi| secondi| minuti| ore| giorni| settimane| mesi| anni| decenni| secoli| millenni',
        last: ' e ',
        empty: 'ora'
    },
    'nl': {
        singular: ' milliseconde| seconde| minuut| uur| dag| weken| maand| jaar| decennium| eeuw| millennium',
        plural: ' milliseconden| seconden| minuten| uur| dagen| weken| maanden| jaar | decennia| eeuwen| millennia',
        last: ' en ',
        empty: 'nu'
    },
    'nl-be': {
        singular: ' milliseconde| seconde| minuut| uur| dag| weken| maand| jaar| decennium| eeuw| millennium',
        plural: ' milliseconden| seconden| minuten| uur| dagen| weken| maanden| jaar | decennia| eeuwen| millennia',
        last: ' en ',
        empty: 'nu'
    },
    'pl': {
        singular: ' milisekunda| drugi| minuta| godzina| dzień| tydzień| miesiąc| rok| dekada| wieku| tysiąclecie',
        plural: ' milisekundy| sekundy| minuty| godziny| dni| tygodnie| miesiące| lata| dziesięciolecia| stulecia| tysiąclecia',
        last: ' i ',
        empty: 'teraz'
    },
    'pt': {
        singular: ' milissegundo | segundo| minuto| hora| dia| semana| mês| ano| década| século| milênio',
        plural: ' milissegundos| segundos| minutos| horas| dias| semanas| meses| anos| décadas| séculos| milênios',
        last: ' e ',
        empty: 'agora'
    },
};

document.addEventListener("DOMContentLoaded", function () {
    function replaceCountdownShortcodes(node) {
        if (node.nodeType !== Node.TEXT_NODE) return;

        const regex = /\[countdown date="([\d-]+ [\d:]+)"\]/g;
        let match, lastIndex = 0;
        const parent = node.parentNode;
        const newNodes = [];

        while ((match = regex.exec(node.textContent)) !== null) {
            // Keep text in front of match
            if (match.index > lastIndex) {
                newNodes.push(document.createTextNode(node.textContent.slice(lastIndex, match.index)));
            }

            const dateString = match[1];
            const targetDate = new Date(dateString);
            const span = document.createElement("span");
            span.id = "countdown-" + targetDate.getTime();
            newNodes.push(span);

            lastIndex = regex.lastIndex;
        }

        // Add text after match
        if (lastIndex < node.textContent.length) {
            newNodes.push(document.createTextNode(node.textContent.slice(lastIndex)));
        }

        // Only replace if the match was found
        if (newNodes.length > 0) {
            newNodes.forEach(newNode => parent.insertBefore(newNode, node));
            parent.removeChild(node);
        }
    }

    function processTextNodes(root) {
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
        const textNodes = [];
        while (walker.nextNode()) {
            textNodes.push(walker.currentNode);
        }
        textNodes.forEach(replaceCountdownShortcodes);
    }

    const regex = /\[countdown date="([\d-]+ [\d:]+)"\]/;

    // Check if the body contains the countdown text
    if (regex.test(document.body.innerHTML)) {
        // It does, iterate all elements and replace with span
        processTextNodes(document.body);
    }

    // Start de countdowns
    document.querySelectorAll("span[id^='countdown-']")
        .forEach((span) => {
            window.setInterval(() => {
                const timestamp = span.id.replace("countdown-", "");

                let result = window.countdown(
                    new Date(),
                    timestamp,
                    countdown.YEARS |
                    countdown.MONTHS |
                    countdown.DAYS |
                    countdown.HOURS |
                    countdown.MINUTES
                );

                window.countdown.resetFormat();
                let localization = translations[document.documentElement.lang === 'de' ? document.documentElement.lang : 'nl'];
                window.countdown.setFormat(localization);

                span.innerHTML = result.toHTML();
            }, 1000);
        });
});